<template>
  <div class="container">
    <div class="row">
      <label>Barkod</label>
      <div>
        <input
          v-model="params.barcode"
          type="text"
          class="form-control"
        >
      </div>
    </div>
    <div class="row">
      <label>Stok Kodu</label>
      <div>
        <input
          v-model="params.stockCode"
          type="text"
          class="form-control"
        >
      </div>
    </div>
    <div class="row">
      <label>Model Kodu</label>
      <div>
        <input
          v-model="params.productMainId"
          type="text"
          placeholder=""
          class="form-control"
        >
      </div>
    </div>
    <div class="row">
      <label>Marka</label>
      <BrandSelect
        v-model="params.brandIds"
        :supplier-product-query-type="supplierProductQueryType"
      />
    </div>
    <div class="row">
      <label>Kategori</label>
      <CategorySelect
        v-model="params.pimCategoryIds"
        name="productCategory"
        :options="getCategoriesList"
        :related-categories="relatedCategories"
        placeholder="Kategori Seçimi"
      />
    </div>
    <div class="btn-container">
      <div class="btn-container-item">
        <button
          class="btn btn-dark"
          @click="onReset"
        >
          SIFIRLA
        </button>
      </div>
      <div class="btn-container-item">
        <button
          class="btn btn-trendyol"
          @click="onFilter"
        >
          FİLTRELE
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import mobile from '@/utils/mobile';
import spinner from '@/utils/spinner';
import BrandSelect from './Components/BrandSelect/Index';
import categoryService from '@/services/category';
import CategorySelect from './Components/CategorySelect/Index';

export default {
  name: 'Filter',
  components: {
    BrandSelect,
    CategorySelect,
  },
  data () {
    return {
      params: {
        barcode: null,
        stockCode: null,
        productMainId: null,
        brandIds: null,
        pimCategoryIds: null,
      },
      // it will be in the params in the future.
      supplierProductQueryType: null,
      categories: [],
      relatedCategories: [],
    };
  },
  computed: {
    getCategoriesList () {
      return this.categories;
    },
  },
  methods: {
    async onReset () {
      this.params = {
        barcode: null,
        stockCode: null,
        productMainId: null,
        brandIds: null,
        pimCategoryIds: null,
      };
      this.onFilter();
    },
    onFilter () {
      const params = { ...this.params };
      if (params.brandIds?.id) {
        params.brandName = params.brandIds.name;
        params.brandIds = params.brandIds.id;
      } else {
        params.brandName = null;
        params.brandIds = null;
      }

      if (params.pimCategoryIds?.id) {
        params.pimCategoryName = params.pimCategoryIds.label;
        params.pimCategoryIds = params.pimCategoryIds.id;
      } else {
        params.pimCategoryName = null;
        params.pimCategoryIds = null;
      }

      mobile.navigationNavigate({
        pageName: 'Product',
        params,
      });
    },
    async getProductCategoriesBySupplier (supplierProductQueryType) {
      const response = await categoryService.getProductCategoriesBySupplier({ type: supplierProductQueryType });
      const relatedCategories = response.categoryIds;
      return relatedCategories;
    },
    async getCategories () {
      const response = await categoryService.getCategories();
      this.categories = response.Categories;
    },
  },
  async created () {
    const { query } = this.$route;
    const params = { ...query };
    this.supplierProductQueryType = params.supplierProductQueryType;
    delete params.supplierProductQueryType;
    if (params.pimCategoryName && params.pimCategoryIds) {
      params.pimCategoryIds = {
        Id: params.pimCategoryIds,
        Name: params.pimCategoryName,
      };
    }
    if (query.brandIds && query.brandName) {
      params.brandIds = {
        label: query.brandName,
        id: query.brandIds,
      };
    }

    this.relatedCategories = await this.getProductCategoriesBySupplier(this.supplierProductQueryType);

    this.params = params;
    await this.getCategories();
    spinner.done();
  },
};
</script>
<style lang="scss" scoped>
  .container {
    padding: 15px 15px 0;
    .row {
      margin-bottom: 15px;

      .date-picker {
        display: flex;

        .date-picker-item {
          padding-right: 8px;
          flex: 1;

          &:last-child {
            padding-left: 7px;
            padding-right: 0;
          }
        }
      }
      label {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 10px;
        display: block;
      }
      &::v-deep .form-control {
        margin-bottom: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
    .btn-container {
      display: flex;

      .btn-container-item {
        padding-right: 8px;
        padding-left: 7px;
        flex: 1;
        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          padding-right: 0;
        }
      }
    }
  }
</style>
